import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { StringRequiredSchema } from '@/utils';

const LoginFormSchema = z.object({
  email: StringRequiredSchema('Please enter a email.'),
  password: StringRequiredSchema('Please enter a password.'),
});

export type LoginForm = z.infer<typeof LoginFormSchema>;

export const loginFormDefaultValues: LoginForm = {
  email: '',
  password: '',
};

export const useLoginForm = () => {
  const form = useForm({
    resolver: zodResolver(LoginFormSchema),
    defaultValues: loginFormDefaultValues,
  });

  return form;
};
